import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Button,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection } from '../../components/footer/ContentSection';
import { CTASection } from '../../components/footer/CTASection';

export const CommunityGuidelinesPage: React.FC = () => {
  const theme = useTheme();

  const guidelines = [
    {
      title: "Respect and Kindness",
      description: "Treat everyone with respect and kindness. We're all here to help and be helped.",
    },
    {
      title: "Professional Conduct",
      description: "Maintain professional standards in all interactions and communications.",
    },
    {
      title: "Privacy and Confidentiality",
      description: "Respect privacy and maintain confidentiality of personal and medical information.",
    },
    {
      title: "Honest Communication",
      description: "Be honest and transparent in all communications and interactions.",
    },
  ];

  return (
    <PageLayout
      title="Community Guidelines"
      subtitle="Our community guidelines help ensure a positive experience for everyone on our platform."
      breadcrumbs={[
        { label: "Support", href: "/support" },
        { label: "Community Guidelines" },
      ]}
    >
      {/* Guidelines */}
      <ContentSection
        title="Community Guidelines"
        subtitle="These guidelines help create a safe, respectful, and positive environment for everyone."
        backgroundColor={theme.palette.grey[50]}
      >
        <Grid container spacing={4}>
          {guidelines.map((guideline, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Box
                sx={{
                  p: 3,
                  border: `1px solid ${theme.palette.grey[300]}`,
                  borderRadius: 2,
                  backgroundColor: 'white',
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 2,
                    color: theme.palette.primary.main,
                  }}
                >
                  {guideline.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: theme.palette.text.secondary,
                    lineHeight: 1.6,
                  }}
                >
                  {guideline.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </ContentSection>

      {/* CTA Section */}
      <CTASection
        title="Questions About Guidelines?"
        subtitle="If you have questions about our community guidelines or need to report a violation, please contact us."
        primaryButton={{
          text: "Contact Support",
          href: "/contact",
        }}
        secondaryButton={{
          text: "Report Violation",
          href: "/report",
          variant: "outlined",
        }}
      />
    </PageLayout>
  );
};
